export const EVENT_TOGGLE = 'toggle::collapse';
export const EVENT_ACCORDION = 'collapse::accordion';
export const EVENT_RECEIPT = 'collapse::toggle';
